export const handleGenericBackendError = (message?: unknown | any) => {
  console.error('An error has occured. Details: ', message);
};
